<template>
  <dirct-inqrys
      v-if="mode == 'list'"
      :fclty-sn="fcltySn"
      @chng-mode="chngMode"/>
  <dirct-inqry-dp
      v-if="mode == 'dp'"
      :bbst-sn="bbstSn"
      @chng-mode="chngMode"/>
  <dirct-inqry-register
      v-if="mode == 'register'"
      :fclty-sn="fcltySn"
      @chng-mode="chngMode"/>
</template>

<script setup>
import {ref, defineProps} from "vue";

import DirctInqrys from "@/views/my-home/dirct-inqrys.vue";
import DirctInqryDp from "@/views/my-home/dirct-inqry-dp.vue";
import DirctInqryRegister from "@/views/my-home/dirct-inqry-register.vue";

const props = defineProps({
  fcltySn: Number
});

const fcltySn = ref(props.fcltySn);
const bbstSn = ref();
const mode = ref('list');
const chngMode = ({mode: setMode, bbstSn: setBbstSn}) => {
  mode.value = setMode;
  if (setBbstSn) bbstSn.value = setBbstSn;
}
</script>

<style scoped>

</style>
